import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {GlobalService} from '../../../global.service';
import {AuthenticationService} from '../../../authentication.service';
import {MatDialog} from '@angular/material';
import {RaceDetailModalComponent} from '../../events/race-detail-modal/race-detail-modal.component';
import {UploadLiveryComponent} from './upload-livery/upload-livery.component';
import {ImagePopupService} from '../../../shared/image-popup/image-popup.service';
import {EventsService} from '../../events/events.service';

@Component({
  selector: 'elastic-team-liveries',
  templateUrl: './team-liveries.component.html',
  styleUrls: ['./team-liveries.component.scss']
})
export class TeamLiveriesComponent implements OnInit {

  @Input() teamId?: any = false;
  @Input() userId?: any = false;

  liveries = [];

  selectedSim: any;
  selectedCar: any = -1;
  searchCtrl: string;
  constructor(
    public globalService: GlobalService,
    public auth: AuthenticationService,
    public dialog: MatDialog,
    public cdr: ChangeDetectorRef,
    public imagePopup: ImagePopupService,
    public eventsService: EventsService
  ) { }

  ngOnInit() {
    this.selectedSim = this.globalService.getActiveSim();
    this.getData();
  }

  setDefault(uuid) {
    this.globalService.setDefaultLivery(uuid).subscribe( (data: any) => {
      if (data) {
        if (data.success) {
          alert("Default livery for that car model updated!");
        }
        this.getData();
      } else {
        alert('Something went wrong');
      }
    });
  }

  getData() {

    this.globalService.isDarkMode();

    if (this.auth.currentUser.patreon > 0) {
      if (this.teamId) {
        this.globalService.getTeamLiveries(this.teamId).subscribe( (data: any) => {
          if (data) {
            this.liveries = data;
            this.cdr.detectChanges();
          }
        });
      }

      if (!this.teamId && this.userId) {
        this.globalService.getUsersLiveriesAll().subscribe( (data: any) => {
          if (data) {
            this.liveries = data;
            this.cdr.detectChanges();
          }
        });
      }
    }

  }

  deleteLivery(uuid) {
    if (confirm("Are you sure?")) {
      this.globalService.deleteLivery(uuid).subscribe( (data: any) => {
        if (data.success) {
          this.getData();
        } else {
          alert(data.message);
        }
      });
    }
  }

  openUploadModal(sim) {
    if (this.auth.currentUser.patreon > 0) {
      this.dialog.open(UploadLiveryComponent, {
        disableClose: false, data: {teamId: this.teamId, userId: this.userId, sim: sim}, minWidth: window.innerWidth - 400 < 200 ? window.innerWidth - 10 : 800, maxWidth: window.innerWidth - 400 < 200 ? window.innerWidth - 10 : 800
      }).afterClosed().subscribe(result => {
        this.getData();
      });
    }
  }

}
